<template>
  <section class='billing-info'>
    <h5>---账单信息---</h5>
    <ul>
      <li>
        <span>订单类型</span>
        <span>{{ billingInfo.orderType }}</span>
      </li>
      <li>
        <span>订单号</span>
        <span>{{ billingInfo.orderNum }}</span>
      </li>
      <li>
        <span>订单状态</span>
        <span>{{ billingInfo.orderStatus }}</span>
      </li>
      <li>
        <span>结算员</span>
        <span>{{ billingInfo.chargeName }}</span>
      </li>
      <li>
        <span>结算时间</span>
        <span>{{ billingInfo.chargeDate }}</span>
      </li>
      <li>
        <span>支付类型</span>
        <span>{{ billingInfo.payType }}</span>
      </li>
      <li>
        <span>交易流水号</span>
        <span>{{ billingInfo.udId }}</span>
      </li>
      <li>
        <span>应收金额</span>
        <span>{{ billingInfo.shouldMoney }}</span>
      </li>
      <li>
        <span>实收金额</span>
        <span>{{ billingInfo.actualMoney}}</span>
      </li>
      <li>
        <span>欠费金额</span>
        <span>{{ billingInfo.arrearsMoney }}</span>
      </li>
      <li>
        <span>补缴金额</span>
        <span>{{ billingInfo.compensationAmount }}</span>
      </li>
    </ul>
  </section>
</template>
<script>
export default {
  name: "billing-info",
  props: {
    billingInfo: {
      type: Object,
      default: () => ({
        orderType: "",
        orderNum: "",
        orderStatus: "",
        chargeName: "",
        chargeDate: "",
        payType: "",
        udId: "",
        shouldMoney: 0,
        actualMoney: 0,
        arrearsMoney: 0,
        suppleMoney: 0,
        
      }),
    },
  },
};
</script>
<style scoped>
.billing-info{
    padding-bottom:20px;
    box-sizing: border-box;
}
h5{
    padding:10px 0;
    box-sizing: border-box;
    font-weight:bold;
}
ul li{
    padding:5px 0;
    box-sizing: border-box;
}
ul li span:nth-child(1){
    display:inline-block;
    /* padding-right:10px;
    box-sizing: border-box; */
    width:70px;
    font-weight: bold;
}
ul li span:nth-child(2) {
    display:inline-block;
  color:#2a9df5;
  font-weight:bold;
}
ul{
    background: #eee;
    padding:10px;
    box-sizing: border-box;
    border-radius: 10px;
}
</style>
